export default __webpack_public_path__ + "static/glow-mojo-08005e31f5743678050453a50c86a025.svg";